import type { FaireProductEntity } from "../../entity_types/product";

export const p_wywqbadwgc: FaireProductEntity = {
  token: "p_wywqbadwgc",
  type: "product",
  name: "mary & joseph christmas mini enclosure notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/4bc4805ede6e12dc3b561365347d3d9ab8ad2de569f561c79b928aa157581277.jpeg",
  galleryImageUrls: [],
  priceDollars: 2,
  description:
    'A mini notecard for petite greetings. Perfect for adding to a gift or popping in a gift card for a pretty (and easy!) presentation. \n\n\nDetails:\n\n- single card + envelope\n- blank inside\n- 2.5" x 3.5"\n- Printed on 120lb superfine paper\n- Original watercolor artwork by Emily Lex\n',
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:51.849Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
